import {useMemo} from 'react';
import type {ValidationResult} from 'schema/form/functions/validators/types';
import type {ManifestationStatus} from 'services/metadata/types';
import {useLocalization} from 'localization';
import {useAssertManifestationEdit} from 'services/metadata';
import {Layout, Spacer, Text} from 'components';
import {ManifestationTitle} from './ManifestationTitle';

type Props = {
  entityId: string;
  status: ManifestationStatus | undefined;
  validation: ValidationResult;
};

export const ManifestationValidationErrorHeader: React.FC<Props> = ({
  entityId,
  status,
  validation,
}) => {
  const manifestation = useAssertManifestationEdit(entityId);

  const localization = useLocalization();
  const {tLoose} = localization;
  const statusLabel = useMemo(() => {
    return status && validation.valid !== 'valid'
      ? tLoose(`entity.manifestation.status.short.${status}`)
      : null;
  }, [status, tLoose, validation.valid]);

  return (
    <Layout horizontal adjustCenter adjustLeft>
      <ManifestationTitle manifestation={manifestation} />
      <Spacer size={1} />
      {statusLabel ? (
        <Text kind="primary" variant="body2">{`(${statusLabel})`}</Text>
      ) : null}
    </Layout>
  );
};
